module.exports = __webpack_public_path__ + "img/TeamComic_021.e8b7284c.png";